export const downloadJS = ({ ids, name, url }) => {
  const start = ids[0];
  const end = ids[ids.length - 1];
  const fileName = `${name}_${start}-${end}.pdf`;

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
};
